import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { MART_TOKEN_KEY, MART_USER_KEY, StorageService } from 'library-explorer';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private route: Router, private storageService: StorageService) {}

  async canActivate(route: ActivatedRouteSnapshot) {
    const requireAuth = route.data['requireAuth'] !== false;    
    const authUserToken = await this.storageService.check4Value(MART_TOKEN_KEY);
    const authUser = await this.storageService.check4Value(MART_USER_KEY);
    const isAuthenticated = !!(authUserToken && authUser);
    
    if (requireAuth === isAuthenticated) {
      return true;
    } else if (requireAuth) {
      this.route.navigate(['main/signin']);
      return false;
    } else {
      this.route.navigate(['main/native/home']); 
      return false;
    }
  }
}
